import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';
import Utils from './common/utils';
import Md5Factory from './md5Factory';

var HttpClient = /*#__PURE__*/function () {
  function HttpClient(settings) {
    var _this = this;

    this.settings = Object.assign({
      file: '',
      uploadServer: '',
      taskIdKey: '_id',
      headers: {},
      uId: '',
      callbackURL: '',
      // 远程回调地址
      getFilePath: '',
      // 获取文件存放路径的请求
      flag: '',
      restoreId: '',
      restoreFlag: '',
      md5Config: {
        md5Worker: '',
        sparkMd5: '',
        onComplete: null,
        type: 'sample'
      },
      onStart: function onStart() {},
      onProgress: function onProgress() {},
      onComplete: function onComplete() {},
      onError: function onError() {}
    }, settings);

    if (!this.settings.file) {
      this.settings.onError && this.settings.onError('file is required');
      return false;
    }

    if (!this.settings.uploadServer) {
      this.settings.onError && this.settings.onError('uploadServer is required');
      return false;
    }

    this.md5Config = this.settings.md5Config || {};
    this.file = this.settings.file;
    this.startIndex = 0;
    this.taskInfo = null;
    this.transferKey = '';
    this.chunkSize = 0;
    this.chunkTotal = 0;
    this.completeSize = 0;
    this.timestamp = 0;
    this.isPause = true; // 是否暂停

    this.needRequestTask = false; // 断线后需要重新请求任务信息

    this.cancelToken = null;
    this.isFormUpload = false;
    this.isStarting = false; // 是否正在启动中。如果是，那么将不能再次调用start接口

    window.addEventListener('online', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('online');

              if (_this.isPause) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              _this.isPause = false;
              _context.next = 6;
              return _this.loop();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    window.addEventListener('offline', function () {
      console.log('offline');
      _this.isPause = true;
      _this.needRequestTask = true;
    });
  }

  var _proto = HttpClient.prototype;

  _proto.getTaskId = function getTaskId() {
    var taskId = '';

    if (this.taskInfo) {
      taskId = this.taskInfo[this.settings.taskIdKey];
    }

    return taskId;
  };

  _proto.slice = function slice(start, chunkSize) {
    if (start === void 0) {
      start = 0;
    }

    if (chunkSize === void 0) {
      chunkSize = this.chunkSize;
    }

    var file = this.file;
    var fileSize = file.size;

    if (fileSize === 0) {
      throw new Error('file size is zero');
    }

    if (start >= fileSize) {
      throw new Error("slice start index overstep the boundary: start:" + start + " file size:" + fileSize);
    }

    var end = start + chunkSize;

    if (end > fileSize) {
      end = fileSize;
    }

    var blobSlice = window.File.prototype.slice || window.File.prototype.mozSlice || window.File.prototype.webkitSlice;
    return blobSlice.call(file, start, end);
  };

  _proto.uploadChunk = /*#__PURE__*/function () {
    var _uploadChunk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(type, chunk) {
      var _this2 = this;

      var formData, taskId, _taskId, callback, isGetMd5, block, md5Config, _factory;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (type === void 0) {
                type = HttpClient.UPLOAD_TYPE.TRANSFER;
              }

              formData = new window.FormData();

              if (type === HttpClient.UPLOAD_TYPE.TASK_INIT) {
                chunk = this.slice(this.startIndex, 1);

                if (this.settings.restoreId) {
                  formData.append('restoreId', this.settings.restoreId);
                }

                if (this.settings.restoreFlag) {
                  formData.append('restoreFlag', this.settings.restoreFlag);
                }

                formData.append('filename', this.file.name);
                formData.append('fileSize', this.file.size);

                if (this.settings.callbackURL) {
                  formData.append('callbackURL', this.settings.callbackURL);
                }

                if (this.settings.getFilePath) {
                  formData.append('getFilePath', this.settings.getFilePath);
                }

                if (this.settings.flag) {
                  formData.append('flag', this.settings.flag);
                }
              } else if (type === HttpClient.UPLOAD_TYPE.TASK_INFO) {
                taskId = this.getTaskId();
                chunk = this.slice(this.startIndex, 1);
                formData.append('taskId', taskId);
              } else {
                _taskId = this.getTaskId();
                formData.append('key', this.transferKey);
                formData.append('taskId', _taskId);
              }

              formData.append('type', type);

              if (this.settings.uId) {
                formData.append('uId', this.settings.uId);
              }

              callback = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formData) {
                  var rs, result, rawKey;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this2._postFile(formData);

                        case 2:
                          rs = _context2.sent;

                          if (type === HttpClient.UPLOAD_TYPE.TRANSFER) {
                            _this2.chunkTotal = _this2.chunkTotal + chunk.size;
                          }

                          result = rs.data.result;
                          rawKey = _this2.decodeKey(result.key);
                          _this2.taskInfo = result.taskInfo;
                          _this2.transferKey = result.key;
                          _this2.startIndex = rawKey.chunkStartIndex;
                          _this2.chunkSize = rawKey.chunkSize;

                        case 10:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function callback(_x3) {
                  return _ref2.apply(this, arguments);
                };
              }();

              if (!(type === HttpClient.UPLOAD_TYPE.TASK_INIT)) {
                _context4.next = 21;
                break;
              }

              isGetMd5 = false;

              block = function block() {
                return new Promise(function (resolve) {
                  var tId = setInterval(function () {
                    if (isGetMd5) {
                      clearInterval(tId);
                      resolve();
                    }
                  }, 500);
                });
              };

              md5Config = {
                type: this.md5Config.type || 'sample',
                onComplete: function () {
                  var _onComplete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(file) {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            isGetMd5 = true;
                            formData.append('md5', file.md5);

                            if (_this2.md5Config.onComplete) {
                              _this2.md5Config.onComplete();
                            }

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  function onComplete(_x4) {
                    return _onComplete.apply(this, arguments);
                  }

                  return onComplete;
                }()
              };

              if (this.md5Config.sparkMd5) {
                md5Config.sparkMd5 = this.md5Config.sparkMd5;
              }

              if (this.md5Config.md5Worker) {
                md5Config.md5Worker = this.md5Config.md5Worker;
              }

              _factory = new Md5Factory(md5Config);

              _factory.addFile(this.file);

              _context4.next = 16;
              return block();

            case 16:
              formData.append('file', chunk);
              _context4.next = 19;
              return callback(formData);

            case 19:
              _context4.next = 24;
              break;

            case 21:
              formData.append('file', chunk);
              _context4.next = 24;
              return callback(formData);

            case 24:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function uploadChunk(_x, _x2) {
      return _uploadChunk.apply(this, arguments);
    }

    return uploadChunk;
  }();

  _proto._postFile = /*#__PURE__*/function () {
    var _postFile2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(formData, axiosConfig) {
      var _this3 = this;

      var uploadServer, rs;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              uploadServer = this.settings.uploadServer;

              if (uploadServer[uploadServer.length - 1] === '/') {
                uploadServer = uploadServer.slice(0, -1);
              }

              uploadServer = uploadServer + '/api/v1/chunk';
              _context5.next = 5;
              return axios.post(uploadServer, formData, Object.assign({}, {
                headers: Object.assign({
                  'Content-Type': 'multipart/form-data'
                }, this.settings.headers || {}),
                onUploadProgress: function onUploadProgress(progressEvent) {
                  if (progressEvent.lengthComputable && _this3.taskInfo) {
                    _this3.formatProgress(progressEvent.loaded, _this3.file.size);
                  }
                }
              }, axiosConfig || {}));

            case 5:
              rs = _context5.sent;

              if (!(rs.status !== 200 || rs.data.status !== '0')) {
                _context5.next = 8;
                break;
              }

              throw new Error(rs.data.message);

            case 8:
              return _context5.abrupt("return", rs);

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function _postFile(_x5, _x6) {
      return _postFile2.apply(this, arguments);
    }

    return _postFile;
  }();

  _proto.formUpload = /*#__PURE__*/function () {
    var _formUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var CancelToken, formData;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              CancelToken = axios.CancelToken;
              this.cancelToken = CancelToken.source();
              this.isFormUpload = true;
              formData = new window.FormData();

              if (this.settings.callbackURL) {
                formData.append('callbackURL', this.settings.callbackURL);
              }

              if (this.settings.getFilePath) {
                formData.append('getFilePath', this.settings.getFilePath);
              }

              if (this.settings.flag) {
                formData.append('flag', this.settings.flag);
              }

              if (this.settings.uId) {
                formData.append('uId', this.settings.flag);
              }

              formData.append('mode', 'simple');
              formData.append('file', this.settings.file);
              _context6.next = 12;
              return this._postFile(formData, {
                cancelToken: this.cancelToken
              });

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function formUpload() {
      return _formUpload.apply(this, arguments);
    }

    return formUpload;
  }();

  _proto.decodeKey = function decodeKey(str) {
    if (!str || str.indexOf('-') === -1) {
      throw new Error('invalid decodeKey string');
    }

    var data = str.split('-');

    if (data.length !== 3) {
      throw new Error('invalid decodeKey string 3');
    }

    return {
      chunkStartIndex: data[0] * 1,
      chunkSize: data[1] * 1,
      lastModified: data[2]
    };
  };

  _proto.formatProgress = function formatProgress(loaded, fileSize) {
    var completeSize = this.completeSize + loaded;
    var percent = completeSize / fileSize * 100;

    if (percent > 100) {
      percent = 100;
    }

    var progress = {
      taskInfo: this.taskInfo,
      loaded: completeSize,
      speed: Utils.formatSize((completeSize / (new Date().getTime() - this.timestamp) | 1) * 1000),
      percent: percent !== 100 ? percent.toFixed(2) : percent
    };
    this.completeSize = completeSize;
    this.settings.onProgress && this.settings.onProgress(this.taskInfo, progress);
  };

  _proto.loop = /*#__PURE__*/function () {
    var _loop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var chunk;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!(this.chunkTotal === this.file.size)) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt("return", false);

            case 2:
              if (!this.needRequestTask) {
                _context7.next = 6;
                break;
              }

              this.needRequestTask = false;
              _context7.next = 6;
              return this.uploadChunk(HttpClient.UPLOAD_TYPE.TASK_INFO);

            case 6:
              chunk = this.slice(this.startIndex, this.chunkSize);
              _context7.next = 9;
              return this.uploadChunk(HttpClient.UPLOAD_TYPE.TRANSFER, chunk);

            case 9:
              if (!(this.taskInfo.status === HttpClient.TASK_STATUS.RUNNING)) {
                _context7.next = 19;
                break;
              }

              if (this.isPause) {
                _context7.next = 15;
                break;
              }

              _context7.next = 13;
              return this.loop();

            case 13:
              _context7.next = 17;
              break;

            case 15:
              _context7.next = 17;
              return HttpClient.stopTaskAPI({
                flag: this.settings.flag,
                taskId: this.taskInfo._id,
                headers: this.settings.headers,
                uploadServer: this.settings.uploadServer
              });

            case 17:
              _context7.next = 21;
              break;

            case 19:
              this.settings.onProgress && this.settings.onProgress(this.taskInfo);
              this.settings.onComplete && this.settings.onComplete(this.taskInfo);

            case 21:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function loop() {
      return _loop.apply(this, arguments);
    }

    return loop;
  }();

  _proto.start = /*#__PURE__*/function () {
    var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!this.isStarting) {
                _context8.next = 3;
                break;
              }

              console.log('starting now. waiting for response');
              return _context8.abrupt("return", false);

            case 3:
              this.isStarting = true;
              _context8.prev = 4;

              if (this.taskInfo) {
                _context8.next = 10;
                break;
              }

              this.timestamp = new Date();
              _context8.next = 9;
              return this.uploadChunk(HttpClient.UPLOAD_TYPE.TASK_INIT);

            case 9:
              this.settings.onStart && this.settings.onStart(this.taskInfo);

            case 10:
              this.isStarting = false;

              if (this.isPause) {
                _context8.next = 13;
                break;
              }

              return _context8.abrupt("return", false);

            case 13:
              this.isPause = false;
              _context8.next = 16;
              return this.loop();

            case 16:
              _context8.next = 24;
              break;

            case 18:
              _context8.prev = 18;
              _context8.t0 = _context8["catch"](4);
              this.isStarting = false;
              this.isPause = true;
              console.log('error ==>', _context8.t0);
              this.settings.onError && this.settings.onError(_context8.t0, this.taskInfo);

            case 24:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this, [[4, 18]]);
    }));

    function start() {
      return _start.apply(this, arguments);
    }

    return start;
  }();

  _proto.stop = /*#__PURE__*/function () {
    var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (this.isFormUpload && this.cancelToken) {
                this.cancelToken.cancel();
              }

              if (!(this.taskInfo && this.taskInfo.status === HttpClient.TASK_STATUS.SUCCESS)) {
                _context9.next = 4;
                break;
              }

              console.log('file uploaded');
              return _context9.abrupt("return", false);

            case 4:
              this.isPause = true;

            case 5:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function stop() {
      return _stop.apply(this, arguments);
    }

    return stop;
  }();

  HttpClient.stopTaskAPI = /*#__PURE__*/function () {
    var _stopTaskAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params) {
      var settings;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              settings = Object.assign({
                flag: '',
                taskId: '',
                uploadServer: '',
                headers: {}
              }, params);
              _context10.next = 3;
              return axios.post(settings.uploadServer + "/api/v1/task/stop", {
                flag: settings.flag,
                taskId: settings.taskId
              }, {
                headers: settings.headers
              });

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function stopTaskAPI(_x7) {
      return _stopTaskAPI.apply(this, arguments);
    }

    return stopTaskAPI;
  }();

  HttpClient.clearChunkFile = /*#__PURE__*/function () {
    var _clearChunkFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(params) {
      var settings;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              settings = Object.assign({
                id: '',
                uploadServer: '',
                headers: {}
              }, params);
              _context11.next = 3;
              return axios.post(settings.uploadServer + "/api/v1/chunk/clear", {
                taskId: settings.id
              }, {
                headers: settings.headers
              });

            case 3:
              _context11.next = 5;
              return HttpClient.deleteTaskAPI(params);

            case 5:
              return _context11.abrupt("return", 'ok');

            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function clearChunkFile(_x8) {
      return _clearChunkFile.apply(this, arguments);
    }

    return clearChunkFile;
  }();

  HttpClient.listTaskAPI = /*#__PURE__*/function () {
    var _listTaskAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
      var settings, rs;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              settings = Object.assign({
                status: '',
                uId: '',
                limit: 30,
                page: 1,
                uploadServer: '',
                headers: {}
              }, params);

              if (settings.limit > 200) {
                settings.limit = 200;
              }

              _context12.next = 4;
              return axios.get(settings.uploadServer + "/api/v1/task", {
                params: {
                  status: settings.status,
                  uId: settings.uId,
                  limit: settings.limit,
                  page: settings.page
                },
                headers: settings.headers
              });

            case 4:
              rs = _context12.sent;
              return _context12.abrupt("return", rs);

            case 6:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function listTaskAPI(_x9) {
      return _listTaskAPI.apply(this, arguments);
    }

    return listTaskAPI;
  }();

  HttpClient.deleteTaskAPI = /*#__PURE__*/function () {
    var _deleteTaskAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
      var settings, rs;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              settings = Object.assign({
                id: '',
                uploadServer: '',
                headers: {}
              }, params);
              _context13.next = 3;
              return axios["delete"](settings.uploadServer + "/api/v1/task/" + settings.id, {
                headers: settings.headers
              });

            case 3:
              rs = _context13.sent;
              return _context13.abrupt("return", rs);

            case 5:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function deleteTaskAPI(_x10) {
      return _deleteTaskAPI.apply(this, arguments);
    }

    return deleteTaskAPI;
  }();

  return HttpClient;
}();

export { HttpClient as default };
HttpClient.UPLOAD_TYPE = {
  TASK_INIT: '0',
  TRANSFER: '1',
  TASK_INFO: '2'
};
HttpClient.TASK_STATUS = {
  WAITING: '0',
  READY: '1',
  RUNNING: '2',
  SUCCESS: '3',
  ABORT: '4',
  // 放弃，意味着任务没用成功，但是因为一些原因，此任务不再执行。
  DELETED: '5',
  FAIL: '1000'
};

HttpClient.download = function (downloadService, file) {
  window.open(downloadService + "/api/v1/task/download?file=" + file, '_blank');
};

export var factory = function factory() {
  var _cache = {};
  var m = {};
  var index = 0;

  var gid = function gid() {
    return "gid_" + index++;
  };

  var getInstance = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(instanceId) {
      var ins;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (instanceId) {
                _context14.next = 2;
                break;
              }

              throw new Error('instanceId is not exist');

            case 2:
              ins = _cache[instanceId];

              if (ins) {
                _context14.next = 5;
                break;
              }

              throw new Error('this instance has been released');

            case 5:
              return _context14.abrupt("return", ins);

            case 6:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function getInstance(_x11) {
      return _ref3.apply(this, arguments);
    };
  }();

  m.create = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(settings) {
      var ins, id;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              ins = new HttpClient(settings);
              id = gid();
              _cache[id] = ins;
              return _context15.abrupt("return", id);

            case 4:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function (_x12) {
      return _ref4.apply(this, arguments);
    };
  }();

  m.start = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(instanceId) {
      var ins;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return getInstance(instanceId);

            case 2:
              ins = _context16.sent;
              _context16.next = 5;
              return ins.start();

            case 5:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function (_x13) {
      return _ref5.apply(this, arguments);
    };
  }();

  m.stop = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(instanceId) {
      var ins;
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return getInstance(instanceId);

            case 2:
              ins = _context17.sent;
              _context17.next = 5;
              return ins.stop();

            case 5:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function (_x14) {
      return _ref6.apply(this, arguments);
    };
  }();

  m.getInstance = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(instanceId) {
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", _cache[instanceId]);

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    return function (_x15) {
      return _ref7.apply(this, arguments);
    };
  }();

  return m;
};